import ListPosts from '../../use-cases/posts/display/ListPosts';
import ListNearbyPosts from '../../use-cases/posts/display/ListNearbyPosts';
import DeletePost from '../../use-cases/posts/delete/DeletePost';
import JoinActivity from '../../use-cases/posts/participation/JoinActivity';
import LeaveActivity from '../../use-cases/posts/participation/LeaveActivity';
import ListCategories from '../../use-cases/categories/ListCategories';
import CreatePost from '../../use-cases/posts/create/CreatePost';
import UpdateOnboardingStep from '../../use-cases/users/UpdateOnboardingStep';
import GetUserProfile from '../../use-cases/users/GetUserProfile';
import UpdateUserPhoto from '../../use-cases/users/UpdateUserPhoto';
import UpdateUserProfile from '../../use-cases/users/UpdateUserProfile';
import GetUserPreferences from '../../use-cases/users/preferences/GetUserPreferences';
import UpdateUserPreferences from '../../use-cases/users/preferences/UpdateUserPreferences';
import InitializeUserPreferences from '../../use-cases/users/preferences/InitializeUserPreferences';
import FollowUser from '../../use-cases/users/social/FollowUser';
import UnfollowUser from '../../use-cases/users/social/UnfollowUser';
import { CancelFollowRequest } from '../../use-cases/users/social/CancelFollowRequest';
import GetPendingFollowRequests from '../../use-cases/users/social/GetPendingFollowRequests';
import { repositories } from '../../infrastructure/config/repositories';
import { SendFollowRequest } from '../../use-cases/users/social/SendFollowRequest';
import { AcceptFollowRequest } from '../../use-cases/users/social/AcceptFollowRequest';
import { RejectFollowRequest } from '../../use-cases/users/social/RejectFollowRequest';
import RemoveFollower from '../../use-cases/users/social/RemoveFollower';
import SubscribeToActivities from '../../use-cases/posts/display/SubscribeToActivities';
import SubscribeToPost from '../../use-cases/posts/display/SubscribeToPost';
import SubscribeToNearbyPosts from '../../use-cases/posts/display/SubscribeToNearbyPosts';
import { GetPost } from '../../use-cases/posts/display/GetPost';

export const useCases = {
  repositories,
  createPost: new CreatePost(repositories.posts),
  listPosts: new ListPosts(repositories.posts),
  listNearbyPosts: new ListNearbyPosts(repositories.posts),
  deletePost: new DeletePost(repositories.posts),
  joinActivity: new JoinActivity(repositories.posts, repositories.users),
  leaveActivity: new LeaveActivity(repositories.posts),
  listCategories: new ListCategories(repositories.categories),
  updateOnboardingStep: new UpdateOnboardingStep(repositories.users),
  getUserProfile: new GetUserProfile(repositories.users),
  updateUserPhoto: new UpdateUserPhoto(repositories.users),
  updateUserProfile: new UpdateUserProfile(repositories.users),
  getUserPreferences: new GetUserPreferences(repositories.users),
  updateUserPreferences: new UpdateUserPreferences(repositories.users),
  initializeUserPreferences: new InitializeUserPreferences(repositories.users),
  
  // Nouveaux use cases sociaux
  followUser: new FollowUser(repositories.users),
  unfollowUser: new UnfollowUser(repositories.users),
  sendFollowRequest: new SendFollowRequest(repositories.users),
  acceptFollowRequest: new AcceptFollowRequest(repositories.users),
  rejectFollowRequest: new RejectFollowRequest(repositories.users),
  cancelFollowRequest: new CancelFollowRequest(repositories.users),
  getPendingFollowRequests: new GetPendingFollowRequests(repositories.users),
  removeFollower: new RemoveFollower(repositories.users),
  
  // Nouveaux use cases pour l'abonnement temps réel aux activités
  subscribeToActivities: new SubscribeToActivities(repositories.posts),
  subscribeToPost: new SubscribeToPost(repositories.posts),
  subscribeToNearbyPosts: new SubscribeToNearbyPosts(repositories.posts),
  
  // Use case pour récupérer un post par son ID
  getPost: new GetPost(repositories.posts)
}; 